import { backgroundTransparent } from '../../../common/common-background';
import { commonInArticleConfig } from '../common-in-article.config';

export const formatConfigUnmarshaller = {
  ...backgroundTransparent,
  ...commonInArticleConfig
};
